import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DiscordLoginButton from './DiscordLoginButton';

const Header = () => {
  const { isAuthenticated, user, login, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const mobileMenuRef = useRef(null);

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };
  
  // Backend returns capitalized property names (C# convention)
  const userName = user?.username || user?.Username || 'User';

  const handleLogout = () => {
    logout();
    closeMobileMenu();
  };

  const handleScrollTo = (sectionId) => {
    closeMobileMenu();
    
    // If not on home page, navigate there first
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    
    // Smooth scroll to section
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        closeMobileMenu();
      }
    };

    if (mobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    closeMobileMenu();
  }, [location]);

  return (
    <nav className="navbar is-fixed-top is-primary" role="navigation" aria-label="main navigation" ref={mobileMenuRef}>
      <div className="container">
        <div className="navbar-brand">
          <Link to="/" className="navbar-item" onClick={closeMobileMenu}>
            <figure className="image is-32x32">
              <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Logo" />
            </figure>
            <strong className="ml-3 is-size-5">AZCOREMSH.NET</strong>
          </Link>

          <button
            type="button"
            className={`navbar-burger ${mobileMenuOpen ? 'is-active' : ''}`}
            aria-label="menu"
            aria-expanded={mobileMenuOpen}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
        </div>

        <div className={`navbar-menu ${mobileMenuOpen ? 'is-active' : ''}`}>
          <div className="navbar-start">
            <Link to="/map" className="navbar-item" onClick={closeMobileMenu}>
              <strong>View Map</strong>
            </Link>
            <Link to="/experiments" className="navbar-item" onClick={closeMobileMenu}>
              <strong>Experiments</strong>
            </Link>
            <a className="navbar-item" onClick={() => handleScrollTo('about')} style={{ cursor: 'pointer' }}>
              About
            </a>
            <a className="navbar-item" onClick={() => handleScrollTo('join')} style={{ cursor: 'pointer' }}>
              Join Us
            </a>
          </div>

          <div className="navbar-end">
            <div className="navbar-item">
              <div className="buttons">
                {isAuthenticated ? (
                  <>
                    <span className="button is-static has-background-white has-text-primary">
                      <strong>{userName}</strong>
                    </span>
                    <button onClick={handleLogout} className="button is-white is-outlined">
                      Logout
                    </button>
                  </>
                ) : (
                  <DiscordLoginButton onClick={() => { login(); closeMobileMenu(); }} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
